module.exports = __webpack_public_path__ + "static/media/card-5.7208019a.png";